var _circle, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 32,
    r: 20,
    fill: "#C9EDB8"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_2056)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1206_2056",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 49,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 6.48499e-05H52.7997V48H4.7998V6.48499e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1206_2056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3983 17.7797C22.7536 17.935 22.0805 18.0173 21.3883 18.0173C16.6693 18.0173 12.8438 14.1942 12.8438 9.47803C12.8438 4.76204 16.6693 0.938824 21.3883 0.938824C26.0322 0.938824 29.8107 4.64138 29.9297 9.25388",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4014 18.0196H14.9844C12.5322 18.0196 10.5462 20.0045 10.5462 22.4552V32.0602H21.0077",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7745 17.7947C40.7745 22.5108 36.949 26.3339 32.23 26.3339C27.511 26.3339 23.6857 22.5108 23.6857 17.7947C23.6857 13.0785 27.511 9.25551 32.23 9.25551C36.949 9.25551 40.7745 13.0785 40.7745 17.7947Z",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0723 30.768C43.0723 28.3173 41.0842 26.3325 38.634 26.3325H25.8266C23.3745 26.3325 21.3884 28.3173 21.3884 30.768V40.3729H35.0911",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8375 43.3198C48.426 45.5678 45.9237 47.0625 43.0722 47.0625C38.6643 47.0625 35.091 43.4914 35.091 39.0863C35.091 34.6811 38.6643 31.11 43.0722 31.11C45.8902 31.11 48.367 32.5695 49.7872 34.7735C49.7996 34.7927 49.8118 34.8119 49.824 34.8312",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0721 36.885V41.2908",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2749 39.0862H40.8691",
    stroke: "#3A8B12",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_2056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.9999,
    height: 47.9999,
    fill: "white",
    transform: "translate(6.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default __webpack_public_path__ + "static/media/new-user.27448c301993b498bcf345044aa9d2ec.svg";
export { ForwardRef as ReactComponent };